import axClient from './constanst';

class CsrfAuthService {
  getSanctum(URL) {
    return axClient.get(`/${URL}`, { withCredentials: true }).then((res) => res);
  }
}

export default new CsrfAuthService();
